<template>
  <div class="account-page-wrapper">
    <div class="container">
      <div v-if="isLoading" class="loading-spinner"></div>
      <template v-else>
        <form v-if="!customerId && !apiKey" @submit.prevent="createCustomer" class="form">
          <div id="card-element" class="card-element"></div>
          <button type="submit" class="submit-btn">Connect</button>
          <p class="disclaimer">*In order for Slant 3D API to create an order we require a connected card to process the
            transaction. You will be billed when you call the Create Order endpoint with a valid order.</p>
        </form>
        <button v-if="customerId && !apiKey" @click="getApiKey()" class="generate-btn">Generate API Key</button>
        <div v-if="apiKey" class="api-display">
          <p>Your API Key</p>
          <div class="api-key"><i class="copy-icon" title="copy to clipboard" @click="copyText">&#128203;</i>{{ apiKey
            }}
          </div>
        </div>
        <div v-if="defaultPaymentMethod" class="payment-method-display">
          <p>Current Payment Method</p>
          <div class="payment-method-info">
            <span class="card-brand">{{ defaultPaymentMethod.card.brand }}</span>
            <span class="card-last4">**** **** **** {{ defaultPaymentMethod.card.last4 }}</span>
            <span class="card-expiry">Expires {{ defaultPaymentMethod.card.exp_month }}/{{
              defaultPaymentMethod.card.exp_year }}</span>
          </div>
        </div>
        <button v-if="customerId" @click="toggleUpdateForm" class="update-btn">Update Payment Method</button>
        <form v-if="showUpdatePaymentForm" @submit.prevent="updatePaymentMethod" class="form update-method">
          <div id="update-card-element" class="card-element"></div>
          <button type="submit" class="submit-btn">Update</button>
        </form>
      </template>
    </div>
    <div class="svg-background">
      <svg id="visual" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">
        <rect x="0" y="0" fill="#e2e2e2"></rect>
        <defs>
          <linearGradient id="grad1_0" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_1" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#7b86f7" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_2" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#a3a4f1" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#7b86f7" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_3" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#a3a4f1" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#c5c2ea" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_4" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#e2e2e2" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#c5c2ea" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_0" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_1" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#7b86f7" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_2" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#7b86f7" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#a3a4f1" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_3" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#c5c2ea" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#a3a4f1" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_4" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#c5c2ea" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#e2e2e2" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <g transform="translate(1920, 1080)">
          <path
            d="M-702 0C-679.3 -42.5 -656.6 -84.9 -649.3 -129.1C-642 -173.4 -650.2 -219.4 -643.9 -266.7C-637.7 -314 -617.1 -362.6 -569.6 -380.6C-522 -398.5 -447.4 -385.9 -418.6 -418.6C-389.8 -451.3 -406.8 -529.2 -390 -583.7C-373.3 -638.2 -322.8 -669.2 -268.3 -647.6C-213.8 -626.1 -155.2 -551.9 -109.8 -552.2C-64.5 -552.5 -32.2 -627.2 0 -702L0 0Z"
            fill="#d4d2e6"></path>
          <path
            d="M-561.6 0C-543.4 -34 -525.2 -67.9 -519.4 -103.3C-513.6 -138.7 -520.1 -175.5 -515.2 -213.4C-510.2 -251.2 -493.7 -290.1 -455.6 -304.5C-417.6 -318.8 -357.9 -308.8 -334.9 -334.9C-311.8 -361 -325.4 -423.4 -312 -467C-298.6 -510.5 -258.2 -535.4 -214.6 -518.1C-171 -500.9 -124.2 -441.5 -87.9 -441.7C-51.6 -442 -25.8 -501.8 0 -561.6L0 0Z"
            fill="#b5b3ee"></path>
          <path
            d="M-421.2 0C-407.6 -25.5 -393.9 -50.9 -389.6 -77.5C-385.2 -104 -390.1 -131.7 -386.4 -160C-382.6 -188.4 -370.3 -217.6 -341.7 -228.3C-313.2 -239.1 -268.4 -231.6 -251.2 -251.2C-233.9 -270.8 -244.1 -317.5 -234 -350.2C-224 -382.9 -193.7 -401.5 -161 -388.6C-128.3 -375.6 -93.1 -331.1 -65.9 -331.3C-38.7 -331.5 -19.3 -376.3 0 -421.2L0 0Z"
            fill="#9095f4"></path>
          <path
            d="M-280.8 0C-271.7 -17 -262.6 -34 -259.7 -51.7C-256.8 -69.4 -260.1 -87.8 -257.6 -106.7C-255.1 -125.6 -246.9 -145 -227.8 -152.2C-208.8 -159.4 -179 -154.4 -167.4 -167.4C-155.9 -180.5 -162.7 -211.7 -156 -233.5C-149.3 -255.3 -129.1 -267.7 -107.3 -259.1C-85.5 -250.4 -62.1 -220.8 -43.9 -220.9C-25.8 -221 -12.9 -250.9 0 -280.8L0 0Z"
            fill="#6078fa"></path>
          <path
            d="M-140.4 0C-135.9 -8.5 -131.3 -17 -129.9 -25.8C-128.4 -34.7 -130 -43.9 -128.8 -53.3C-127.5 -62.8 -123.4 -72.5 -113.9 -76.1C-104.4 -79.7 -89.5 -77.2 -83.7 -83.7C-78 -90.3 -81.4 -105.8 -78 -116.7C-74.7 -127.6 -64.6 -133.8 -53.7 -129.5C-42.8 -125.2 -31 -110.4 -22 -110.4C-12.9 -110.5 -6.4 -125.4 0 -140.4L0 0Z"
            fill="#3a6afd"></path>
        </g>
        <g transform="translate(0, 0)">
          <path
            d="M702 0C636.1 36.8 570.2 73.5 546.3 108.7C522.4 143.8 540.4 177.3 566.3 234.6C592.2 291.9 626 372.9 583.7 390C541.4 407.1 423 360.3 376.2 376.2C329.3 392.1 354 470.6 335.6 502.2C317.1 533.8 255.5 518.4 210.5 508.1C165.4 497.8 136.9 492.5 104.6 525.7C72.2 558.9 36.1 630.4 0 702L0 0Z"
            fill="#d4d2e6"></path>
          <path
            d="M561.6 0C508.9 29.4 456.2 58.8 437 86.9C417.9 115 432.3 141.8 453.1 187.7C473.8 233.5 500.8 298.3 467 312C433.1 325.7 338.4 288.2 300.9 300.9C263.5 313.6 283.2 376.5 268.5 401.8C253.7 427 204.4 414.8 168.4 406.5C132.3 398.3 109.5 394 83.7 420.6C57.8 447.1 28.9 504.3 0 561.6L0 0Z"
            fill="#b5b3ee"></path>
          <path
            d="M421.2 0C381.7 22.1 342.1 44.1 327.8 65.2C313.4 86.3 324.3 106.4 339.8 140.8C355.3 175.1 375.6 223.7 350.2 234C324.8 244.3 253.8 216.2 225.7 225.7C197.6 235.2 212.4 282.4 201.3 301.3C190.3 320.3 153.3 311.1 126.3 304.9C99.3 298.7 82.1 295.5 62.7 315.4C43.3 335.3 21.7 378.3 0 421.2L0 0Z"
            fill="#9095f4"></path>
          <path
            d="M280.8 0C254.4 14.7 228.1 29.4 218.5 43.5C209 57.5 216.2 70.9 226.5 93.8C236.9 116.7 250.4 149.2 233.5 156C216.6 162.8 169.2 144.1 150.5 150.5C131.7 156.8 141.6 188.2 134.2 200.9C126.8 213.5 102.2 207.4 84.2 203.3C66.2 199.1 54.8 197 41.8 210.3C28.9 223.5 14.4 252.2 0 280.8L0 0Z"
            fill="#6078fa"></path>
          <path
            d="M140.4 0C127.2 7.4 114 14.7 109.3 21.7C104.5 28.8 108.1 35.5 113.3 46.9C118.4 58.4 125.2 74.6 116.7 78C108.3 81.4 84.6 72.1 75.2 75.2C65.9 78.4 70.8 94.1 67.1 100.4C63.4 106.8 51.1 103.7 42.1 101.6C33.1 99.6 27.4 98.5 20.9 105.1C14.4 111.8 7.2 126.1 0 140.4L0 0Z"
            fill="#3a6afd"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { loadStripe } from "@stripe/stripe-js";
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { doc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { stripeServices } from "@/services/StripeServices";
import { db } from '../firebase';
import { gsap } from 'gsap';

export default {
  setup() {
    const isLoading = ref(true);
    const apiKey = ref('');
    const defaultPaymentMethod = ref(null)
    const customerId = ref('');
    const showUpdatePaymentForm = ref(false);
    const currentUser = ref(null);
    const stripe = ref(null);
    const elements = ref(null);
    const card = ref(null);
    const updateCard = ref(null);

    const storeInFirebase = async (apiKey, customerId, userId) => {
      if (!apiKey || !customerId || !userId) {
        console.error("One or more parameters are undefined", { apiKey, customerId, userId });
        return;
      }


      const userRef = doc(db, 'users', apiKey);
      await setDoc(userRef, {
        apiKey: apiKey,
        customerId: customerId,
        userId: userId
      }, { merge: true });

    };

    const animatePaths = () => {
      const paths = document.querySelectorAll('#visual path');

      paths.forEach((path, index) => {
        gsap.to(path, {
          duration: 4,
          ease: 'power1.inOut',
          repeat: -1,
          yoyo: true,
          attr: {
            transform: `translate(${30 * Math.sin(index)}, ${30 * Math.cos(index)})`
          }
        });
      });
    };

    const createCustomer = async () => {
      document.body.style.cursor = 'wait';
      const { paymentMethod } = await stripe.value.createPaymentMethod({
        type: 'card',
        card: card.value
      });

      if (paymentMethod) {
        try {
          const auth = getAuth();
          const user = auth.currentUser;

          if (!user) {
            console.error('No authenticated user found');
            return;
          }

          const response = await stripeServices.createPaymentMethod(user.email, paymentMethod.id);
          customerId.value = response.data.customerId;

          await getApiKey();
          document.body.style.cursor = 'default';
        } catch (error) {
          console.error('Failed to create customer', error);
          document.body.style.cursor = 'default';
        }
      }
    };

    const toggleUpdateForm = () => {
      showUpdatePaymentForm.value = true;
      nextTick(() => {
        mountStripeComponent('update-card-element', updateCard);
      });
    };

    const getDefaultPaymentMethod = async () => {
      let stripeDefaultPaymentMethod = await stripeServices.getDefaultPaymentMethod()
      defaultPaymentMethod.value = stripeDefaultPaymentMethod
    }

    const updatePaymentMethod = async () => {
      const { paymentMethod } = await stripe.value.createPaymentMethod({
        type: 'card',
        card: updateCard.value
      });

      if (paymentMethod) {
        try {
          const auth = getAuth();
          const user = auth.currentUser;

          isLoading.value = true;

          if (!user) {
            console.error('No authenticated user found');
            return;
          }

          const response = await stripeServices.updatePaymentMethod(paymentMethod.id, customerId.value);
          alert('Payment method updated successfully');


          if (response) {
            showUpdatePaymentForm.value = false;
            await getDefaultPaymentMethod(); // Refresh the displayed payment method
          } else {
            alert('There was an error updating your payment method');
          }

          document.body.style.cursor = 'default';
        } catch (error) {
          console.error('Failed to update payment method', error);
        } finally {
          isLoading.value = false;
        }
      }
    };

    const mountStripeComponent = async (elementId, cardRef) => {
      if (!stripe.value) {
        stripe.value = await loadStripe('pk_live_J8SAYNrhdffTaDDBVQpG7Jjj');
      }
      elements.value = stripe.value.elements();
      cardRef.value = elements.value.create('card');

      // Use nextTick to ensure the DOM is updated before mounting
      nextTick(() => {
        const element = document.getElementById(elementId);
        if (element) {
          cardRef.value.mount(`#${elementId}`);
        } else {
          console.error(`Element with id ${elementId} not found`);
        }
      });
    };

    const copyText = () => {
      navigator.clipboard.writeText(apiKey.value)
        .then(() => {
          alert('API Key copied to clipboard!');
        })
        .catch((error) => {
          console.error('Failed to copy API Key:', error);
        });
    };

    const getUserDataByUID = async (uid) => {
      const usersCollection = collection(db, 'users');
      const q = query(usersCollection, where("userId", "==", uid));
      const querySnapshot = await getDocs(q);

      let userData = null;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
      });
      currentUser.value = userData;
      if (userData.customerId) {
        customerId.value = userData.customerId;
      }
      return userData;
    };

    const getApiKey = async () => {
      try {
        const response = await axios.post('https://www.slant3dapi.com/api/apikeys');
        const { key } = response.data;

        apiKey.value = key;

        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
          console.error('No authenticated user found');
          return;
        }

        await storeInFirebase(key, customerId.value, user.uid);

      } catch (error) {
        console.error('Failed to get API Key', error);
      }
    };

    onMounted(async () => {
      animatePaths();

      try {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const userDoc = await getUserDataByUID(user.uid);
          if (userDoc && userDoc.apiKey) {
            apiKey.value = userDoc.apiKey;
            await getDefaultPaymentMethod();
          }
        }
      } catch (error) {
        console.error('Failed to fetch user API key from Firebase', error);
      } finally {
        isLoading.value = false;
        // Mount Stripe component after loading is complete and DOM is updated
        nextTick(() => {
          if (!customerId.value && !apiKey.value) {
            mountStripeComponent('card-element', card);
          }
        });
      }
    });


    return {
      apiKey,
      customerId,
      createCustomer,
      showUpdatePaymentForm,
      toggleUpdateForm,
      updatePaymentMethod,
      getApiKey,
      defaultPaymentMethod,
      copyText,
      isLoading
    };
  }
};
</script>

<style scoped>
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.account-page-wrapper {
  min-height: 100dvh;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto';
}

.svg-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: #e2e2e2;
}

#visual {
  display: block;
  width: 100%;
  height: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  margin: 50px 1rem;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ececec;
}

.api-display,
.payment-method-display {
  margin-top: 20px;
  width: 100%;
  background-color: #f7f7f9;
  padding: 15px;
  border-radius: 4px;
  text-align: center;
}

.api-key,
.payment-method-info {
  word-break: break-all;
  padding: 10px;
  border: 1px dashed #333;
  margin-top: 10px;
}

.payment-method-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.update-method {
  width: 100%;
}

.card-brand {
  font-weight: bold;
  text-transform: capitalize;
  margin-bottom: 5px;
}

.card-last4 {
  font-size: 1.2em;
  margin-bottom: 5px;
}

.card-expiry {
  font-size: 0.9em;
  color: #666;
}

.copy-icon:hover {
  cursor: pointer;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.card-element {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn {
  background-color: #007bff;
  color: #fff;
}

.submit-btn:hover {
  background-color: #0056b3;
}

.generate-btn {
  margin-top: 20px;
  background-color: #28a745;
  color: #fff;
}

.generate-btn:hover {
  background-color: #208835;
}

.update-btn {
  margin-top: 20px;
  background-color: #ffa500;
  color: #fff;
}

.update-btn:hover {
  background-color: #ff8c00;
}
</style>